import { imprimirDescarregoMercadoria } from 'modulo-gerencial-erp-pacotes-impressora-termica';

import { imprimirServicoNovo, buscarDadosImpressao } from '../utils';

async function imprimir(id, query = '', usar_nova_impressao = false) {
  /*  if (!usar_nova_impressao) {
    return await imprimirServicoAntigo(id, 17, query);
  }

  const dados = await buscarDadosImpressao(id, 17);

  const { comandos } = layout(adapter(dados));

  const response = await imprimirServicoNovo(
    id,
    'nota-descarrego-mercadoria',
    comandos,
  );
  return response.data; */
  return await imprimirDescarregoMercadoria({
    id,
    buscarDadosImpressao,
    chamarServicoImpressoraTermica: imprimirServicoNovo,
    query,
  });
}

export default imprimir;
